"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useExtractedValues = void 0;
var react_1 = require("react");
var operators_1 = require("rxjs/operators");
var utils_1 = require("../../utils");
var debounce_time_def_1 = require("../configs/debounce-time-def");
var useExtractedValues = function (pointerPosRelative$, virtualImgRectAbsolute$, cropTemporaryRectRelative$, addBboxTemporaryRectRelative$, resizeBboxTemporaryRectRelative$, bboxesRelative$, selectedId$, highlightId$, cursorType$, mode$, imgVisibleAreaRectAbsolute$, canvasRectSizeAbsolute$) {
    /* extract values */
    var virtualImgRectAbsolute = (0, utils_1.useStreamValue)(virtualImgRectAbsolute$.pipe((0, operators_1.auditTime)(debounce_time_def_1.bufferTimeDef.zoom)), (0, utils_1.IRect)());
    var pointerPosRelative = (0, utils_1.useStreamValue)(pointerPosRelative$.pipe((0, operators_1.auditTime)(debounce_time_def_1.bufferTimeDef.pointer)), undefined);
    var cropTemporaryRectRelative = (0, utils_1.useStreamValue)(cropTemporaryRectRelative$, (0, utils_1.IRect)());
    var addBboxTemporaryRectRelative = (0, utils_1.useStreamValue)(addBboxTemporaryRectRelative$, (0, utils_1.IRect)());
    var resizeBboxTemporaryRectRelative = (0, utils_1.useStreamValue)(resizeBboxTemporaryRectRelative$, (0, utils_1.IRect)());
    var bboxesRelative = (0, utils_1.useStreamValue)(bboxesRelative$.pipe((0, operators_1.auditTime)(debounce_time_def_1.bufferTimeDef.bboxes)), (0, utils_1.IList)());
    var selectedId = (0, utils_1.useStreamValue)(selectedId$, undefined);
    var highlightId = (0, utils_1.useStreamValue)(highlightId$, undefined);
    var cursorType = (0, utils_1.useStreamValue)(cursorType$, 'default');
    var mode = (0, utils_1.useStreamValue)(mode$, 'rectbox-editor-standby');
    var imgVisibleAreaRectAbsolute = (0, utils_1.useStreamValue)(imgVisibleAreaRectAbsolute$.pipe((0, operators_1.auditTime)(debounce_time_def_1.bufferTimeDef.zoom)), (0, utils_1.IRect)());
    var canvasRectSize = (0, utils_1.useStreamValue)(canvasRectSizeAbsolute$.pipe((0, operators_1.auditTime)(debounce_time_def_1.bufferTimeDef.canvasResize)), (0, utils_1.IRectSize)());
    // absolute values
    // 相対位置から絶対位置への変換関数．canvas高速化のためにtoAbsolute**内で数値を整数に丸めている．
    var toAbsPos = (0, react_1.useCallback)(function (p) { return (0, utils_1.roundPosToInt)((0, utils_1.toAbsolutePos)(virtualImgRectAbsolute)(p)); }, [virtualImgRectAbsolute]);
    var toAbsRect = (0, react_1.useCallback)(function (r) { return (0, utils_1.roundRectToInt)((0, utils_1.toAbsoluteRect)(virtualImgRectAbsolute)(r)); }, [virtualImgRectAbsolute]);
    var pointerPosAbsolute = (0, react_1.useMemo)(function () {
        return pointerPosRelative === undefined
            ? undefined
            : toAbsPos(pointerPosRelative);
    }, [toAbsPos, pointerPosRelative]);
    var cropTemporaryRectAbsolute = (0, react_1.useMemo)(function () { return toAbsRect(cropTemporaryRectRelative); }, [toAbsRect, cropTemporaryRectRelative]);
    var addBboxTemporaryRectAbsolute = (0, react_1.useMemo)(function () { return toAbsRect(addBboxTemporaryRectRelative); }, [toAbsRect, addBboxTemporaryRectRelative]);
    var resizeBboxTemporaryRectAbsolute = (0, react_1.useMemo)(function () { return toAbsRect(resizeBboxTemporaryRectRelative); }, [toAbsRect, resizeBboxTemporaryRectRelative]);
    /**
     * @description 現在の画像表示サイズに合わせてbboxの画面上の位置を計算したもの
     */
    var bboxesAbsolute = (0, react_1.useMemo)(function () { return bboxesRelative.map(function (bb) { return bb.update('rect', toAbsRect); }); }, [bboxesRelative, toAbsRect]);
    return {
        pointerPosAbsolute: pointerPosAbsolute,
        imgVisibleAreaRectAbsolute: imgVisibleAreaRectAbsolute,
        virtualImgRectAbsolute: virtualImgRectAbsolute,
        canvasRectSize: canvasRectSize,
        cropTemporaryRectAbsolute: cropTemporaryRectAbsolute,
        addBboxTemporaryRectAbsolute: addBboxTemporaryRectAbsolute,
        resizeBboxTemporaryRectAbsolute: resizeBboxTemporaryRectAbsolute,
        bboxesAbsolute: bboxesAbsolute,
        highlightId: highlightId,
        selectedId: selectedId,
        cursorType: cursorType,
        mode: mode
    };
};
exports.useExtractedValues = useExtractedValues;
